module.exports = __webpack_public_path__ + "static/media/linkedin.82b52eca.svg";